<miq-filter-bar-label [props]="props"></miq-filter-bar-label>

<mat-form-field appearance="outline">
  <input
    matInput
    autocomplete="no-autofill"
    [placeholder]="props?.placeholder"
    [formControl]="control"
    aria-label="props.name"
    (change)="doSearch($event)"
    (keydown.enter)="doSearch($event)"
  />
</mat-form-field>
